export const iconFontAwesomeLogisticsAnchor = (
	<i className="fa-solid fa-anchor"></i>
);
